import { defineComponent as x, useSlots as g, useCssModule as y, inject as k, computed as d, onBeforeMount as b, createElementBlock as r, openBlock as i, normalizeClass as a, unref as t, createCommentVNode as w, createElementVNode as n, createBlock as B, toDisplayString as u, createTextVNode as N, renderSlot as C } from "vue";
import { t as E } from "./locale.js";
import T from "./Icon.js";
import { S as z } from "./keys-C8Zfr_By.js";
import { _ as M } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const S = { key: 1 }, I = /* @__PURE__ */ x({
  __name: "Step",
  props: {
    active: { type: Boolean, default: !1 },
    completed: { type: Boolean, default: !1 },
    error: { type: Boolean, default: !1 },
    text: {},
    nested: { type: Boolean, default: !1 },
    step: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 }
  },
  setup(m) {
    const e = m, _ = g(), s = y(), l = k(z), c = d(() => (l == null ? void 0 : l.orientation) === "horizontal"), p = d(() => (l == null ? void 0 : l.theme) === "light"), o = l == null ? void 0 : l.showResponsiveNav, v = d(() => e.loading ? "working" : e.completed ? "circle-check" : "circle-info"), h = d(
      () => E("ll.stepper.currentStep", { num: e.step, total: String(l == null ? void 0 : l.stepCount.value) })
    );
    return b(() => {
      l && l.registerStep(e.nested);
    }), (f, K) => (i(), r("li", {
      class: a(["stash-step tw-relative tw-flex tw-w-full", [
        t(s).step,
        {
          [t(s)["nested-step--active"]]: e.nested && e.active,
          "last:tw-w-auto": c.value && !t(o),
          [t(s)["stash-step--singular"]]: t(o),
          "tw-relative tw-w-full tw-shrink-0 tw-snap-start tw-flex-col tw-justify-center": t(o)
        }
      ]]),
      "data-test": "stash-step"
    }, [
      e.nested ? w("", !0) : (i(), r("div", {
        key: 0,
        class: a(["stash-step__indicator tw-flex tw-flex-col tw-items-center", { "tw-mr-3": !t(o) }]),
        "data-test": "stash-step|indicator"
      }, [
        n("div", {
          class: a([
            t(s).circle,
            {
              [t(s)["circle--todo"]]: !e.error && !e.active && !e.completed,
              [t(s)["circle--error"]]: e.error && !e.active,
              [t(s)["circle--completed"]]: e.completed && !e.active,
              [t(s)["circle--active"]]: e.active,
              [t(s)["circle--loading"]]: e.loading
            }
          ])
        }, [
          (e.completed || e.error || e.loading) && !e.active ? (i(), B(T, {
            key: 0,
            name: v.value,
            class: a({ "fx-spin": e.loading }),
            size: "dense"
          }, null, 8, ["name", "class"])) : (i(), r("span", S, u(e.step), 1))
        ], 2),
        n("div", {
          class: a(["tw-my-1.5 tw-w-px tw-bg-ice-500", [
            t(s).line,
            { [t(s)["line--expanded"]]: e.completed || e.active, "tw-hidden": c.value }
          ]])
        }, null, 2)
      ], 2)),
      n("div", {
        class: a(["tw-flex", [
          {
            "tw-w-full tw-flex-row tw-items-center": c.value,
            "tw-mt-1.5 tw-justify-center": t(o),
            "tw-flex-col": !c.value || t(o)
          }
        ]])
      }, [
        n("div", {
          class: a(["stash-step__title tw-whitespace-nowrap", [
            t(s).title,
            {
              "tw-cursor-pointer": !e.active && (e.completed || e.error),
              "tw-cursor-not-allowed": e.disabled,
              "tw-text-ice-900": p.value,
              "!tw-font-semibold": e.active,
              "tw-text-white": !e.disabled && !p.value,
              "tw-place-self-center": t(o)
            }
          ]]),
          "data-test": "stash-step|title"
        }, [
          N(u(e.text) + " ", 1),
          t(o) ? (i(), r("p", {
            key: 0,
            class: a(["stash-step__pagination-label tw-mb-0 tw-whitespace-nowrap tw-text-center tw-text-xs", p.value ? "tw-text-ice-700" : "tw-text-white"]),
            "data-test": "stash-step|pagination-label"
          }, u(h.value), 3)) : w("", !0)
        ], 2),
        c.value ? (i(), r("div", {
          key: 0,
          class: a([
            t(s).line,
            {
              [t(s)["line--expanded"]]: e.completed || e.active,
              "tw-mx-1.5 tw-border-t group-last:tw-hidden": !t(o)
            }
          ])
        }, null, 2)) : w("", !0),
        n("div", {
          class: a(["stash-step--nested-steps", { "tw-pb-9": !f.nested && !t(_).default, "tw-hidden": c.value }])
        }, [
          n("ul", {
            class: a([t(s).nested, { "tw-hidden": !t(_).default }])
          }, [
            C(f.$slots, "default")
          ], 2)
        ], 2)
      ], 2)
    ], 2));
  }
}), R = "_step_73127_2", V = "_title_73127_11", P = "_line_73127_22", $ = "_circle_73127_62", D = "_nested_73127_18", H = {
  step: R,
  title: V,
  "nested-step--active": "_nested-step--active_73127_18",
  line: P,
  "line--expanded": "_line--expanded_73127_27",
  "stash-step--singular": "_stash-step--singular_73127_31",
  circle: $,
  "circle--todo": "_circle--todo_73127_75",
  "circle--active": "_circle--active_73127_81",
  "circle--loading": "_circle--loading_73127_87",
  "circle--completed": "_circle--completed_73127_94",
  "circle--error": "_circle--error_73127_101",
  nested: D
}, J = {
  $style: H
}, F = /* @__PURE__ */ M(I, [["__cssModules", J]]);
export {
  F as default
};
//# sourceMappingURL=Step.js.map
